import React, { useState, useRef, useEffect } from "react";
import { useForm, Controller } from "react-hook-form";
import {
  getFeatureAll,
  deleteFeature,
  createFeature,
  updateFeature,
  softDeleteFeature,
  getFeatureAllType,
  getFeatureTypeByFeature,
} from "../../Services/FeatureService";
import Swal from "sweetalert2";
import MTable from "../../Components/MTable/MTable";
import { InputSwitch } from "primereact/inputswitch";
import Overlay from "../../Components/Overlay/Overlay";
import { toastError, toastSuccess } from "../../Components/Toasts/Toast";
import { handlerFormError, uuid } from "../../Utils/Utils";
import { NavLink } from "react-router-dom";
import { useSelector } from "react-redux";
import EditButton from "../../Components/Button/EditButton";
import DeleteButton from "../../Components/Button/DeleteButton";
import { getSubcategoryAll } from "../../Services/SubcategoryService";
import { getSubSubcategoryAll } from "../../Services/SubSubcategoryService";
import ModalSelectSubCategories from "../../Components/Feature/Modal/ModalSelectSubCategories";
import ModalSelectSubSubCategory from "../../Components/Feature/Modal/ModalSelectSubSubCategory";

const { $ } = window;
let processingId = -1;
const modalId = "#feature-select-sub-category";
const modalSubId = "#feature-select-sub-sub-category";

const FeaturePage = () => {
  let { userInfo } = useSelector((state) => state.auth);
  const [showAll, setShowAll] = useState(false);
  const mTable = useRef();
  const mTableSubCat = useRef();
  const mTableSubSubCat = useRef();
  const {
    register,
    handleSubmit,
    reset,
    control,
    setValue,
    formState: { errors },
    clearErrors,
  } = useForm({
    defaultValues: {
      sub_category_name: "",
      selectedSubCat: "",
      id_sub_category: "",
      id_sub_sub_category: "",
      feature_name: "",
      description: "",
      status: true,
      disabledSelect: false,
    },
  });

  const [state, setState] = useState({
    showForm: false,
    feature: {
      id_sub_category: "",
      id_sub_sub_category: "",
      feature_name: "",
      description: "",
      status: true,
      disabledSelect: false,
      detail: [
        // {
        //     id_feature: "",
        //     feature_name: "",
        //     type_name: "",
        //     score: 0
        // }
      ],
      errors: [],
    },
    detailDelete: [],
    selectedSubCat: "",
    subcategory: [],
    processing: false,
  });

  const startProcessing = () => {
    processingId = setTimeout(() => {
      setState({ ...state, processing: true });
    }, 150);
  };

  const stopProcessing = () => {
    clearTimeout(processingId);
    setState({ ...state, processing: false });
  };

  const onAddData = () => {
    if (!userInfo.access.master_feature.can_create) {
      return;
    }
    onReset();
    setState({
      ...state,
      showForm: true,
      disabledSelect: false,
      feature: {
        id_sub_category: "",
        id_sub_sub_category: "",
        feature_name: "",
        description: "",
        status: true,
        disabledSelect: false,
        detail: [],
        errors: [],
      },
    });
  };

  const onActiveChange = (item) => (e) => {
    if (!userInfo.access.master.can_update) {
      toastError("You dont have permission for this action");
      return;
    }

    const status = e.target.value ? "Activate" : "Inactive";
    softDeleteFeature(item.id, { status: e.target.value })
      .then((res) => {
        toastSuccess(`${status} ${item.status} success`);
        mTable.current.refresh();
      })
      .catch(({ response: { err } }) => {
        toastError(`${status} ${item.status} Failed.`);
      });
  };

  const onChangeInputText = (e, index) => {
    const _feature = { ...feature };
    _feature.errors = _feature.errors.filter((item) => item !== `${index}0`);
    if (e.target.value.length >= 200) {
      toastError("Max character 200");
      return;
    } else {
      _feature.detail[index][e.target.name] = e.target.value;
      setState({ ...state, feature: _feature });
    }
  };

  const onChangeInputScore = (e, index) => {
    const _feature = { ...feature };
    _feature.errors = _feature.errors.filter((item) => item !== `${index}1`);
    if (
      parseInt(e.target.value) < 0 ||
      e.target.value == "" ||
      e.target.value == null ||
      e.target.value == undefined ||
      e.target.value == " " ||
      parseInt(e.target.value) == 0 ||
      e.target.value == "0"
    ) {
      _feature.detail[index][e.target.name] = 0;
      setState({ ...state, feature: _feature });
    } else {
      _feature.detail[index][e.target.name] = parseInt(e.target.value);
      setState({ ...state, feature: _feature });
    }
  };

  const onClickSubCat = (item) => {
    const _feature = { ...feature };
    if (item.id != _feature.id_sub_category) {
      setValue("id_sub_sub_category", "");
      setValue("sub_sub_category_name", "");
      _feature.id_sub_sub_category = "";
      mTableSubSubCat.current.refresh();
    }
    setValue("id_sub_category", item.id);
    setValue("sub_category_name", item.sub_category_name);
    _feature.id_sub_category = item.id;

    setState({ ...state, feature: _feature });

    onCloseModal();
  };

  const onClickSubSubCat = (item) => {
    const _feature = { ...feature };
    setValue("id_sub_sub_category", item.id);
    setValue("sub_sub_category_name", item.sub_sub_category_name);
    _feature.id_sub_sub_category = item.id;
    clearErrors("sub_sub_category_name");
    setState({ ...state, feature: _feature });

    onCloseModal();
  };

  const onRowChecked = (checked) => {
    setState({ ...state, checked });
  };

  const removeData = (id) => {
    deleteFeature(
      id,
      (res) => {
        if (res.status == 200 || res.status == 201) {
          Swal.fire({
            icon: "success",
            title: "Delete data success",
            text: "Data has been deleted!",
          }).then((res) => {
            mTable.current.refresh();
          });
        }
      },
      ({ response: { data } }) => {
        Swal.fire({
          icon: "error",
          title: "Delete data fail",
          text: data.message,
        });
      }
    );
  };

  const onEdit = (item) => () => {
    if (!userInfo.access.master_feature.can_update) {
      return;
    }
    reset(item);
    const _feature = { ...item };

    const results = [getFeatureTypeByFeature(item.id).then((res) => res.data)];

    Promise.all(results).then((results) => {
      const [feature_type] = results;
      const _disabledSelect = feature_type.feature_map.disable;

      _feature.detail = feature_type.data.data;
      _feature.errors = [];

      setState({
        ...state,
        feature: _feature,
        showForm: true,
        disabledSelect: _disabledSelect,
      });
    });
  };

  const onRemove = (item) => () => {
    if (!userInfo.access.master_feature.can_delete) {
      toastError("You dont have permission for this action");
      return;
    }

    Swal.fire({
      icon: "question",
      title: "Are you sure?",
      text: "Deleted data can not be restored!",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
    }).then(({ isConfirmed }) => {
      if (isConfirmed) {
        removeData(item.id);
      }
    });
  };

  const onReset = () => {
    reset({
      id_sub_category: "",
      sub_category_name: "",
      sub_sub_category_name: "",
      feature_name: "",
      description: "",
      selectedSubCat: "",
      status: true,
      disabledSelect: false,
    });
    setState({
      ...state,
      feature: {
        id_sub_category: "",
        feature_name: "",
        description: "",
        status: true,
        disabledSelect: false,
        detail: [],
      },
      detailDelete: [],
      selectedSubCat: "",
      subcategory: [],
    });
  };

  const onCloseForm = () => {
    reset({
      id_sub_category: "",
      sub_category_name: "",
      feature_name: "",
      description: "",
      status: true,
      disabledSelect: false,
    });
    setState({
      ...state,
      feature: {},
      detailDelete: [],
      selectedSubCat: "",
      showForm: false,
      subcategory: [],
    });
  };

  const onCloseModal = () => {
    setTimeout(() => {
      $(modalId).modal("hide");
      $(modalSubId).modal("hide");
    }, 150);
  };

  const onAddSubCatModal = (a) => {
    mTableSubCat.current.refresh();
    setTimeout(() => {
      $(modalId).modal("show");
    }, 150);
  };

  const onAddSubSubCatModal = (a) => {
    mTableSubSubCat.current.refresh();
    setTimeout(() => {
      $(modalSubId).modal("show");
    }, 150);
  };

  const delRowDetail = (index) => {
    const _feature = { ...feature };
    const _detailDelete = [...detailDelete];

    if (_feature.detail[index].id > 0) {
      _detailDelete.push(_feature.detail[index]);
    }
    _feature.detail.splice(index, 1);

    setState({ ...state, feature: _feature, detailDelete: _detailDelete });
  };

  const addRowDetail = () => {
    const _feature = { ...feature };
    if (Object.keys(_feature).length > 0) {
      if (_feature.id == undefined) {
        _feature.detail.push({
          id_feature: "",
          type_name: "",
          score: 0,
        });
        setState({ ...state, feature: _feature });
      } else {
        _feature.detail.push({
          id_feature: _feature.id,
          type_name: "",
          score: 0,
        });
        setState({ ...state, feature: _feature });
      }
    } else {
      const _feature = {
        id_sub_category: "",
        feature_name: "",
        description: "",
        status: true,
        detail: [
          {
            id_feature: "",
            type_name: "",
            score: 0,
          },
        ],
      };
      setState({ ...state, feature: _feature });
    }
  };

  const onSubmit = (data) => {
    data.detail = feature.detail;
    data.delete = detailDelete;

    if (!validateFeatureType()) {
      return;
    }

    startProcessing();
    const response = feature.id
      ? updateFeature(feature.id, data)
      : createFeature(data);
    response
      .then((res) => {
        if (res.status == 200 || res.status == 201) {
          Swal.fire({
            icon: "success",
            title: res.data.message,
            text: "Data has been saved!",
          }).then((r) => {
            mTable.current.refresh();
            feature.id ? onCloseForm() : onReset();
          });
        }
      })
      .catch(({ response: { data } }) => {
        handlerFormError(data);
      })
      .finally((_) => stopProcessing());
  };

  const validateFeatureType = () => {
    const _feature = { ...feature };
    let result = true;
    feature.detail.map((item, i) => {
      if (item.type_name == "" || item.score == 0) {
        result = false;
        if (item.type_name == "") {
          _feature.errors?.push(`${i}0`);
          toastError("Type Name is required");
        } else if (item.score == 0) {
          _feature.errors?.push(`${i}1`);
          toastError("Score is required");
        }
        setState((prev) => ({ ...prev, feature: _feature }));
      }
    });
    return result;
  };

  const columns = [
    {
      id: uuid(),
      title: "Sub Category",
      field: "sub_category_name",
      sortable: true,
    },
    {
      id: uuid(),
      title: "Sub Sub Category",
      field: "sub_sub_category_name",
      sortable: true,
    },
    {
      id: uuid(),
      title: "Feature Name",
      field: "feature_name",
      sortable: true,
    },
    { id: uuid(), title: "Description", field: "description", sortable: true },
    {
      id: uuid(),
      title: "Active",
      field: "status",
      render: (item) => {
        if (item.status === true) {
          return <span className="badge badge-success">Active</span>;
        } else {
          return <span className="badge badge-secondary">Inactive</span>;
        }
      },
    },
    {
      id: uuid(),
      title: "",
      sortable: true,
      style: { width: 200 },
      render: (item) => {
        return (
          <div>
            {userInfo.access.master_feature.can_update && (
              <EditButton title="Edit" onClick={onEdit(item)} />
            )}
            {userInfo.access.master_feature.can_delete && (
              <DeleteButton title="Remove" onClick={onRemove(item)} />
            )}
          </div>
        );
      },
    },
  ];

  const getFilteredSubSubcategoryAll = (_params, onSuccess, onError) => {
    if (feature.id_sub_category) {
      _params.filter = "id_sub_category:" + feature.id_sub_category;
    }
    return getSubSubcategoryAll(_params, onSuccess, onError);
  };

  const { feature, detailDelete, processing, showForm, disabledSelect } = state;

  const showAllFunc = () => {
    setShowAll(!showAll);
    mTable.current.refresh();
  };

  const propsTable = {
    columns,
    showAllState: showAll,
    showAllFunc,
    getData: (params) => {
      if (showAll === false) {
        if (params.filterAnd) params.filterAnd += "," + `status:true`;
        else params.filterAnd = "status:true";
      }
      return getFeatureAll({ ...params });
    },
    showIndex: true,
    enableFilter: true,
    showAddButton: !userInfo.access.master_feature.can_create ? false : true,
  };

  const propsModalSubCategories = {
    useState,
    useRef,
    modalId,
    onCloseModal,
    getSubcategoryAll,
    useSelector,
    Overlay,
    uuid,
    MTable,
    onClickSubCat,
    onRowChecked,
    onAddSubCatModal,
  };

  const propsModalSubSubCategories = {
    useState,
    useRef,
    modalId: modalSubId,
    onCloseModal,
    getSubSubcategoryAll: getFilteredSubSubcategoryAll,
    useSelector,
    Overlay,
    uuid,
    MTable,
    onClickSubSubCat,
    onRowChecked,
    onAddSubSubCatModal,
  };
  return (
    <div>
      <div className="content-wrapper">
        <div className="content-header">
          <div className="container-fluid">
            <div className="row mb-2">
              <div className="col-sm-6">
                <h4
                  style={{
                    marginTop: "0.5rem",
                    marginLeft: "0.2rem",
                    fontWeight: "400",
                  }}
                >
                  {showForm
                    ? "Feature Creation/Modification"
                    : "Feature Management"}
                </h4>
                <h6
                  style={{
                    marginLeft: "0.2rem",
                    fontWeight: "200",
                    letterSpacing: "1.2px",
                  }}
                >
                  {showForm ? "Add/Edit a Feature" : "Database of Features"}
                </h6>
              </div>
              <div className="col-sm-6">
                <ol className="breadcrumb float-sm-right">
                  <li className="breadcrumb-item">
                    <NavLink to="/home">Home</NavLink>
                  </li>
                  <li className="breadcrumb-item active">Feature</li>
                </ol>
              </div>
            </div>
          </div>
        </div>
        <section className="content">
          <div className="container-fluid">
            <div className="row">
              <div className="col-md-12">
                <div className="card">
                  <Overlay display={processing} />

                  <form name="form-detail" onSubmit={handleSubmit(onSubmit)}>
                    <div className="card-body">
                      <div
                        className={`${
                          !showForm
                            ? "card__side--front-show"
                            : "card__side--front"
                        }`}
                      >
                        <MTable
                          ref={mTable}
                          {...propsTable}
                          onAddData={onAddData}
                          showIndex={true}
                        />
                      </div>

                      <div
                        className={`${
                          showForm
                            ? "card__side--back-show"
                            : "card__side--back"
                        }`}
                      >
                        <div className="row">
                          <div className="col-md-5">
                            <div className="d-flex justify-content-between">
                              <div className="form-group col-md-10">
                                <label htmlFor="sub_category_name">
                                  Sub Category Name
                                </label>
                                <div className="form-group">
                                  <input
                                    type="text"
                                    name="sub_category_name"
                                    className="form-control"
                                    {...register("sub_category_name", {
                                      required: {
                                        value: true,
                                        message:
                                          "sub category name is required!",
                                      },
                                    })}
                                    placeholder="Sub Category Name"
                                    readOnly
                                  />
                                </div>
                              </div>
                              <div
                                className="form-group col-md-2"
                                style={{ marginTop: 32 }}
                              >
                                <button
                                  type="button"
                                  className="btn btn-warning"
                                  onClick={() => onAddSubCatModal()}
                                  disabled={disabledSelect}
                                >
                                  {" "}
                                  Select{" "}
                                </button>
                              </div>
                            </div>
                            <div className="form-group">
                              <input
                                type="hidden"
                                name="id_sub_category"
                                className="form-control"
                                {...register("id_sub_category", {
                                  required: {
                                    value: true,
                                    message: "sub category is required!",
                                  },
                                })}
                                placeholder="Sub Category Id"
                                readOnly
                              />
                            </div>
                            <div className="d-flex justify-content-between">
                              <div className="form-group col-md-10">
                                <label htmlFor="sub_category_name">
                                  Sub Sub Category Name
                                </label>
                                <div className="form-group">
                                  <input
                                    type="text"
                                    name="sub_sub_category_name"
                                    className="form-control"
                                    {...register("sub_sub_category_name", {
                                      required: {
                                        value: true,
                                        message:
                                          "sub sub category name is required!",
                                      },
                                    })}
                                    placeholder="Sub Sub Category Name"
                                    readOnly
                                  />
                                  {errors.sub_sub_category_name && (
                                    <span
                                      className="text-danger"
                                      style={{ fontSize: 14 }}
                                    >
                                      {errors.sub_sub_category_name.message}
                                    </span>
                                  )}
                                </div>
                              </div>
                              <div
                                className="form-group col-md-2"
                                style={{ marginTop: 32 }}
                              >
                                <button
                                  type="button"
                                  className="btn btn-warning"
                                  onClick={() => onAddSubSubCatModal()}
                                  disabled={disabledSelect}
                                >
                                  {" "}
                                  Select{" "}
                                </button>
                              </div>
                            </div>
                            <div className="form-group">
                              <input
                                type="hidden"
                                name="id_sub_sub_category"
                                className="form-control"
                                {...register("id_sub_sub_category", {
                                  required: {
                                    value: true,
                                    message: "sub sub category is required!",
                                  },
                                })}
                                placeholder="Sub Sub Category Id"
                                readOnly
                              />
                            </div>
                            <div className="form-group">
                              <label htmlFor="feature_name">Feature Name</label>
                              <input
                                id="feature_name"
                                {...register("feature_name", {
                                  required: {
                                    value: true,
                                    message: "Feature Name is required!",
                                  },
                                })}
                                placeholder="Feature Name"
                                className="form-control"
                              />
                              {errors.feature_name && (
                                <span
                                  className="text-danger"
                                  style={{ fontSize: 14 }}
                                >
                                  {errors.feature_name.message}
                                </span>
                              )}
                            </div>

                            <div className="form-group">
                              <label htmlFor="description">Description</label>
                              <input
                                id="description"
                                {...register("description", {
                                  required: {
                                    value: true,
                                    message: "Description is required!",
                                  },
                                })}
                                placeholder="Description"
                                className="form-control"
                              />
                              {errors.description && (
                                <span
                                  className="text-danger"
                                  style={{ fontSize: 14 }}
                                >
                                  {errors.description.message}
                                </span>
                              )}
                            </div>

                            {/* <div className='form-group'>
                                                            <label htmlFor="score">score</label>
                                                            <input type="number" id="score" {...register("score",{ required: { value: true, message: 'is required!' }, min: { value: 0, message: 'must be > 0' }})} placeholder='Score' className='form-control' />
                                                            {errors.score && (<span className='text-danger' style={{ fontSize: 14 }}>{errors.score.message}</span>)}
                                                        </div> */}

                            <div className="form-group">
                              <label htmlFor="status">Active</label>
                              <div>
                                <Controller
                                  name="status"
                                  control={control}
                                  render={({ field }) => {
                                    return (
                                      <InputSwitch
                                        {...field}
                                        checked={field.value}
                                      />
                                    );
                                  }}
                                />
                              </div>
                            </div>
                          </div>
                          <div className="col-md-1 d-flex justify-content-center">
                            <div
                              class="d-flex"
                              style={{
                                height: "100%",
                                width: 1,
                                backgroundColor: "#909090",
                              }}
                            ></div>
                          </div>
                          <div className="col-md-5">
                            <label style={{ marginLeft: -50 }}>
                              Add Feature Type
                            </label>
                            {feature.detail &&
                              feature.detail.map((elem, j) => (
                                <div key={`ftrd` + j}>
                                  <div className="d-flex justify-content-between">
                                    <div className="form-group">
                                      <label htmlFor="type_name">
                                        Type Name
                                      </label>
                                      <input
                                        id={`type_name-` + j}
                                        name="type_name"
                                        onChange={(e) =>
                                          onChangeInputText(e, j)
                                        }
                                        value={elem.type_name}
                                        placeholder="Type Name"
                                        className="form-control"
                                        style={
                                          feature.errors?.includes(`${j}0`)
                                            ? {
                                                borderColor: "red",
                                                color: "red",
                                              }
                                            : {}
                                        }
                                      />
                                    </div>

                                    <div className="form-group">
                                      <label htmlFor="score">score</label>
                                      <input
                                        type="number"
                                        id={`number` + j}
                                        name="score"
                                        onChange={(e) =>
                                          onChangeInputScore(e, j)
                                        }
                                        value={elem.score}
                                        placeholder="Score"
                                        className="form-control"
                                        style={
                                          feature.errors?.includes(`${j}1`)
                                            ? {
                                                borderColor: "red",
                                                color: "red",
                                              }
                                            : {}
                                        }
                                      />
                                    </div>
                                    <div
                                      className="form-group"
                                      style={{ marginTop: 32 }}
                                    >
                                      <p
                                        style={
                                          elem.notdelete
                                            ? {
                                                cursor: "not-allowed",
                                                color: "grey",
                                              }
                                            : {
                                                cursor: "pointer",
                                                color: "red",
                                              }
                                        }
                                        onClick={() => {
                                          if (!elem.notdelete) {
                                            delRowDetail(j);
                                          }
                                        }}
                                      >
                                        <i class="fa fa-times" />
                                      </p>
                                    </div>
                                  </div>
                                </div>
                              ))}
                            <div
                              className="d-flex"
                              style={{
                                marginTop: 32,
                                justifyContent: "flex-end",
                              }}
                            >
                              <p
                                style={{ cursor: "pointer", color: "#ffc107" }}
                                onClick={() => addRowDetail()}
                              >
                                <i class="fa fa-plus" /> Add
                              </p>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>

                    {showForm && (
                      <div className="card-footer delay">
                        <div className="row">
                          <div className="col-md-12">
                            <div
                              className="d-flex"
                              style={{ justifyContent: "flex-end" }}
                            >
                              <button
                                type="button"
                                className="btn btn-default mr-3"
                                style={{ width: 100 }}
                                onClick={onCloseForm}
                              >
                                <i className="fa fa-times" /> Close
                              </button>
                              <button
                                type="button"
                                className="btn btn-danger mr-3"
                                style={{ width: 100 }}
                                onClick={onReset}
                              >
                                <i className="fa fa-sync" /> Clear
                              </button>
                              {feature.detail &&
                                feature.detail !== null &&
                                feature.id_sub_category !== "" &&
                                feature.id_sub_category !== undefined &&
                                feature.id_sub_category !== null && (
                                  <button
                                    type="submit"
                                    className="btn btn-dark"
                                    style={{ width: 100 }}
                                    disabled={
                                      control._formValues.id
                                        ? !userInfo.access.master_feature
                                            .can_update
                                        : !userInfo.access.master_feature
                                            .can_create
                                    }
                                  >
                                    <i className="fa fa-save" /> Save
                                  </button>
                                )}
                            </div>
                          </div>
                        </div>
                      </div>
                    )}
                  </form>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
      <ModalSelectSubCategories
        mTable={mTableSubCat}
        {...propsModalSubCategories}
      />
      <ModalSelectSubSubCategory
        mTable={mTableSubSubCat}
        {...propsModalSubSubCategories}
      />
    </div>
  );
};

export default FeaturePage;
